/* eslint-disable @typescript-eslint/no-non-null-assertion */
if ( process.env.REACT_APP_MAPBOX_ACCESS_TOKEN === null )
{
    console.error( "Missing maxbox API token" );
}
export const mapBoxAccessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN!;
